import { useCallback, useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import { api } from "@/lib/api";
import { useFiles } from "@/context/FilesContext";
import { FileIcon } from "@/components/files/FileIcon";
import { CompanySuggestion } from "@/components/files/CompanySuggestion";

export function CompanySuggestionsCard() {
  const { openFile, refreshKey } = useFiles();
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/ai/company-suggestions").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load, refreshKey]);
  if (!items.length) return null;
  return (
    <div className="bg-white border border-amber-200 rounded-xl" data-testid="company-suggestions-card">
      <div className="flex items-center gap-2 px-5 py-4 border-b">
        <Building2 className="h-4 w-4 text-amber-700" />
        <h2 className="font-display font-bold text-base">Société à vérifier</h2>
        <span className="text-xs bg-amber-100 text-amber-800 rounded-full px-2 py-0.5" data-testid="company-suggestions-count">{items.length}</span>
      </div>
      <div className="p-3 space-y-3 max-h-[28rem] overflow-y-auto">
        {items.map((f) => (
          <div key={f.id} className="space-y-1.5">
            <button className="flex items-center gap-2 text-sm font-medium hover:text-[#1E3A8A] min-w-0" onClick={() => openFile(f.id)} data-testid={`company-suggestion-open-${f.id}`}>
              <FileIcon file={f} size="sm" /><span className="truncate">{f.name}</span>
            </button>
            <CompanySuggestion file={f} compact onDone={load} />
          </div>
        ))}
      </div>
    </div>
  );
}
